import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';
import { useFetch } from 'src/utils/hooks/useFetch';
import { NewsApi } from 'src/api/base/News';

import { ICreateGuestModel, IGuestInfo } from 'src/api/base/Guest/types';

import { NewNewsForm } from './NewNewsForm';

type PNewContactFormContainer = {
  onSuccess: (guest: IGuestInfo) => void;
};

export const NewNewsFormCreate: React.FC<PNewContactFormContainer> = (
  props,
) => {
  const { onSuccess } = props;
  const [{ response, isLoading, error }, doFetch] = useFetch<
    any,
    ICreateGuestModel
  >(NewsApi.createNews);

  useResponseFormHandler({ error, response });

  useEffect(() => {
    if (response) {
      onSuccess(response?.data?.data);
    }
  }, [response, onSuccess]);

  return (
    <NewNewsForm
      onSubmit={(data) => {
        doFetch(data);
      }}
      loading={isLoading}
      errors={error?.response?.data.errors}
      shouldResetAfterSuccess={response}
    />
  );
};

export const NewNewsFormUpdate: React.FC<PNewContactFormContainer> = () => {
  const [{ response }, doFetch] = useFetch<any, any>(NewsApi.getSingleNews);

  const { id }:any = useParams();

  useEffect(() => {
    doFetch(id);
  }, [id, doFetch]);

  const [
    { response: responseEdit, isLoading: isLoadingEdit, error: errorEdit },
    doEdit,
  ] = useFetch<any, any>(NewsApi.updateNews as any);

  useResponseFormHandler({ response: responseEdit, error: errorEdit });

  return (
    (response || responseEdit) && 
      <NewNewsForm
        loading={isLoadingEdit}
        onSubmit={(data) => {
          doEdit({ id, data });
        }}
        errors={errorEdit?.response?.data?.errors}
        newsTemplate={
          responseEdit?.data?.data?.data || response?.data?.data?.data
        }
        shouldResetAfterSuccess={responseEdit}
      />
  );
};
